import isObject from "isobject"

export const filterToString = (filter: Object | undefined): string =>
{
    if (filter)
    {
        const entries = Object.entries(filter)
        let res: Array<string> = []

        entries.forEach(i =>
        {
            const key = i[0]
            const value = i[1]

            if (key === "withoutLoadingIndicator" || key === "controller" || value === undefined || value === null || value === "")
            {
                return
            }
            else if (key.toLowerCase().includes("datefrom") || key.toLowerCase().includes("dateto"))
            {
                res.push(`${key}=${encodeURI(value)}`)
            }
            else if (isObject(value)) res.push(`${key}=${value?.value}`)
            else if (Array.isArray(value))
            {
                value.forEach(({value}) => res.push(`${key}=${value}`))
            }
            else res.push(`${key}=${value}`)
        })

        if (res.length > 0) return "?" + res.join("&")
        else return ""
    }
    return ""
}
